import React, {useContext} from 'react';
import AuthContext from "../context/AuthProvider";
import {Link, Navigate} from "react-router";
import {Helmet} from "react-helmet";
import arko from "../assets/arko.jpg";
import FraudioLoader from "./FraudioLoader";
import LogoutButton from "./LogoutButton";

function Arko() {
    const { auth } = useContext(AuthContext);

    if (auth !== "arko@audiotime.com.tr") {
        return <Navigate to="/giris" />;
    }

    return (
        <React.Fragment>
            <Helmet>
                <script src={`${process.env.PUBLIC_URL}/assets/js/fraudio.min.js`} type="text/javascript"/>
                <link rel="stylesheet" href={`${process.env.PUBLIC_URL}/assets/css/fraudio.css`}/>
            </Helmet>

            <div className="breadcumb bg-overlay-one">
                <div className="breadcumb__bottom-thumb">
                    <img src="assets/images/thumb/banner-bid.png" alt=""/>
                </div>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="breadcumb__wrapper">
                                <span className="breadcumb__title">
                                    <span className="breadcumb__title-lighten"
                                          style={{color: "#0a0a0a"}}>ARKO NEM</span> DEMO
                                </span>
                                <ul className="breadcumb__list">
                                    <li className="breadcumb__item">
                                        <Link to="/" className="breadcumb__link" reloadDocument>
                                            <i className="las la-home"/> Ana Sayfa
                                        </Link>
                                    </li>
                                    <li className="breadcumb__item"> //</li>
                                    <li className="breadcumb__item-text">ARKO NEM</li>
                                </ul>
                                <LogoutButton />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br/>

            <div className="live-youtube-wrapper style-two pb-120 pt-60 mt-0">
                <div className="container">
                    <div className="live-youtube style-two">
                        <div className="row gy-4 align-items-center">
                            <div className="col-lg-4">
                                <div className="youtube-rj">
                                    <div className="youtube-rj__thumb">
                                        <img src={arko} alt="Arko Nem"/>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 ps-lg-5 pe-lg-5">
                                <div className="row">
                                    <div className="col-lg-7">
                                        <div className="youtube-content">
                                            <h6 className="youtube-content__subtitle">Hava Durumu & UV Bazlı</h6>
                                            <h2 className="youtube-content__title" style={{color: "#fff"}}>
                                                Arko Nem Ekstra Serum
                                            </h2>
                                            <p className="youtube-content__desc">
                                                Yapay zeka, dinleyicinin bulunduğu lokasyonun anlık hava durumunu,
                                                sıcaklığını ve UV seviyesini tespit ederek reklam metnini o an üretir ve
                                                seslendirir. Güneşli ve UV'nin yüksek olduğu günlerde cildin ekstra
                                                desteğe ihtiyacı olduğu mesajı öne çıkar; hava değiştikçe reklam da
                                                kendini günceller.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-lg-0 mt-3">
                                        <FraudioLoader src="https://audiotime.clerkai.app/arko.php"
                                                       title="Arko Nem Ekstra Serum" artist="Yapay Zeka"/>
                                    </div>

                                    <div className="col-lg-12 mt-4">
                                        <div style={{
                                            background: "rgba(255,255,255,0.04)",
                                            border: "1px solid rgba(255,255,255,0.10)",
                                            borderLeft: "3px solid #4fc3c7",
                                            borderRadius: "12px",
                                            padding: "22px 26px",
                                        }}>
                                            <p style={{
                                                color: "#4fc3c7",
                                                fontSize: "11px",
                                                letterSpacing: "3px",
                                                textTransform: "uppercase",
                                                marginBottom: "12px",
                                            }}>Örnek Senaryo Metni</p>
                                            <p style={{
                                                color: "rgba(255,255,255,0.75)",
                                                fontSize: "15px",
                                                lineHeight: 1.8,
                                                margin: 0,
                                            }}>
                                                Bugün İstanbul'da güneş kendini gösteriyor. Hava 28 derece.
                                                UV seviyesi yüksek. Cildin gün boyu daha fazla desteğe ihtiyaç
                                                duyabilir.<br/>
                                                Bugün Glow zamanı. Arko Nem Ekstra Serum.<br/>
                                                <span style={{color: "#fff", fontStyle: "italic"}}>
                                                    "Yakışır tabii cildime."
                                                </span>
                                            </p>
                                            <p style={{
                                                color: "rgba(255,255,255,0.35)",
                                                fontSize: "12px",
                                                marginTop: "14px",
                                                marginBottom: 0,
                                            }}>
                                                Kent, sıcaklık ve UV değerleri anlık verilerle otomatik değişir.
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}

export default Arko;
